import React, { Component } from "react";
import { Modal, Button, textarea } from "react-bootstrap";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import moment from 'moment';
import * as actions from "../actions/index";
import * as constants from "../const";
import PropTypes from 'prop-types'; 

class CommentsModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isComment: false
    };
  }

  // cancelling comment screen (Admin)
  onCancelAdminComments() {
    var workday = this.props.workday,
        cmts = this.refs.txtComments,
        route = this.props.role.route,
        modalToOpen = route =="U" && constants.certifyByAdmin ? "Certify_Modal" : "Certified_Modal";
    this.props.hideModal(false, "Comments_Modal");
    this.showModal( // showing previous modal 
      workday.Id,
      modalToOpen,
      workday.wdy_certify_status
    );
    this.props.onChangesInActivity(false); // resetting changes if any
  }

  // cancelling comment screen (Employee)
  onCancelEmpComments() {
    var workday = this.props.workday;
    this.props.hideModal(false, "Comments_Modal"); // hiding comments modal
    this.props.onActErr(false, false);
    //this.props.resetWorkday(this.props.defaultWorkday); // resetting workday
    this.props.onShowModal("Certify_Modal"); // shwoing cetify modal
    //this.props.onChangesInActivity(false); // resetting changes if any
  }

  showModal(workdayId, modalName, certifyStatus) {
    this.props.onShowModal(modalName);
  };

  // redering modal based on role and modal
  renderModal() {
    if (this.props.showModal && this.props.modalName == constants.hosModals.Certified_Modal) {
      return <HoursOfServiceModal workday={this.props.workday} />;
    } else if (
      this.props.showModal &&
      this.props.modalName == constants.hosModals.Certify_Modal
    ) {
      return <ActivityModal />;
    }
  }

  renderAdminButton() {
    var role = this.props.role.role,
        workday = this.props.workday;
    if (this.props.action === constants.REJECT) {
      return (
        <div className="text-center">
          <button
            className="btn btn-default btnDefaultColor btnWidth"
            onClick={() => this.onCancelAdminComments()}>
            {" "}Cancel{" "}
          </button>
          <button className="btn btn-danger btnDangerColor btnWidth" onClick={() => this.onRejectButton()}>
            UnCertify
          </button>
        </div>
      );
    } else {
      return (
        <div className="text-center">
          <button
            className="btn btn-default btnDefaultColor btnWidth"
            onClick={() => this.onCancelAdminComments()}>
            {" "}Cancel{" "}
          </button>
          <button className="btn btn-primary btnPrimaryColor btnWidth" onClick={() => this.onAcceptButton()}>
            Accept
          </button>
        </div>
      );
    }
  }

  renderEmployeeButton() {
    return (
      <div className="text-center">
        <button
          className="btn btn-default btnDefaultColor btnWidth"
          onClick={() => this.onCancelEmpComments()}>Cancel{" "}
        </button>
        <button
          className="btn btn-primary btnPrimaryColor btnWidth"
          disabled={this.props.certifyError}
          onClick={() => this.onCertifyButton()}>Save
        </button>
      </div>
    );
  }

  // on accepting the claims by admin
  onAcceptButton() {  
    var cmts = this.refs.txtComments,
        route = this.props.role.route,
        certifyByAdmin = route =="U" && constants.certifyByAdmin ? true : false,
        role = this.props.role.role,
        changes = certifyByAdmin ? true:false;
    if (cmts.value != "") {
      this.props.onCertify(
        this.props.workday.Id,
        this.props.workday,
        cmts,
        changes,
        role,
        certifyByAdmin
      );
    } else {
      this.setState({ isComment: true });
    }
  }

  // on rejecting the claims by admin
  onRejectButton() {
    var cmts = this.refs.txtComments,
        role = this.props.role.role, rejectStatus = true;
    if (cmts.value != "") {
      this.props.onRejectClaim(
        this.props.workday.Id,
        role,
        rejectStatus,
        cmts,
        this.props.workday
      );
    } else {
      this.setState({ isComment: true });
    }
  }

  onCertifyButton() {
    
    var certifyByAdmin = constants.certifyByAdmin,
        role = this.props.role.role,
        cmts = this.refs.txtComments;
    let changes = true;
    let isHosSave = localStorage.getItem("isHosCertifyClicked")== undefined || localStorage.getItem("isHosCertifyClicked") =='false'  ?false: true;
 
    if(this.props.workday.wdy_hos_11h59value){
      changes = false;
    }
    if (cmts.value.trim() != "") {
      
      if(this.props.islogsUser){

        let inputParam={
          workdayId:this.props.workday.Id,
          workday:this.props.workday,
          cmts:cmts,
          changes:changes,
          role:this.props.authDetails.role,
          certifyByAdmin:certifyByAdmin,
          isHosSave:isHosSave,
          userId:this.props.authDetails.userId,
          historicalStartDate: this.props.historicalStartDate? this.props.historicalStartDate:'',
          historicalEndDate: this.props.historicalEndDate?this.props.historicalEndDate:''
        };

        this.props.onCertifyHOSLog(inputParam);
      }
      else{
        this.props.onCertify(
          this.props.workday.Id,
          this.props.workday,
          cmts,
          changes,
          role && role.trim().length>0 ?role:this.props.authDetails.role,
          certifyByAdmin
        );
      }
     
    } else {
      this.setState({ isComment: true });
    }
  }

  // render header for comment
  renderCommentHeader() {
    var workday = this.props.workday,
        full_name = workday.emp_full_name.split(" "),
        first_name = full_name[1], 
        last_name = full_name[0];
    if (this.props.action === constants.REJECT) {
      return (
        <span>UnCertify {first_name} {last_name}</span>
      );
    } else {
      return (
        <span>{first_name} {last_name}</span>
      );
    }
  }

  // closing error box
  oncloseErrPop() {
    this.props.onActErr(false, true);  // para1: errpop, para2: acterr
  }

  totalActivityHours(){
    if(!this.props.islogsUser){
      return 0;
    }

    var workday = this.props.workday;
    let totalHours = 0;
    if (workday && Object.keys(workday).length > 0 && workday.duty_activity && Object.keys(workday.duty_activity).length > 0) {
      workday.duty_activity.map(function(act, index){
        if(!act.isDeleted){
          let act_name = act.dty_act_name_updated?act.dty_act_name_updated : act.dty_act_name;
          let isSplitBreak = act_name.toString().toLocaleLowerCase().includes('split break');
          let isDeadheadEnd = act_name.toString().toLowerCase().includes('deadhead from');
          let limbo = act_name.toString().toLowerCase().includes('limbo');
          if(!isSplitBreak && !isDeadheadEnd && !limbo){
            let act_start_date = act.dty_act_start_date ? act.dty_act_start_date : workday.wdy_date,
              act_end_date = act.dty_act_end_date ? act.dty_act_end_date : workday.wdy_date,
              act_start_time = act.dty_act_start_time_updated ? act.dty_act_start_time_updated : act.dty_act_start_time,
              act_end_time = act.dty_act_end_time_updated ? act.dty_act_end_time_updated : act.dty_act_end_time
            let a =  moment(act_start_date+' '+act_start_time, 'MM/DD/YYYY hh:mm A');
            let b =  moment(act_end_date+' '+act_end_time, 'MM/DD/YYYY hh:mm A');
            totalHours += b.diff(a, 'minutes');
          }
        }
      });
    }
    
    return totalHours;
  }

  // render comments component
  renderCommentsModal() {
    if (this.props.showModal) {
      var role = this.props.role.role;
      return (
        <Modal
          show={
            this.props.showModal && this.props.modalName == constants.hosModals.Comments_Modal
          }
          onHide={() => role === constants.roles.ADMIN_ROLE ? this.onCancelAdminComments() : this.onCancelEmpComments()} >
          <Modal.Header closeButton>
            <div className="cmt-modal-header">
              {this.renderCommentHeader()}
              <br />
              <span> {this.props.workday.wdy_date} Service Date </span>
            </div>
          </Modal.Header>
          <div className={!this.props.activityErrPopup ? ( "hidden" ) : (
                        "errAlertDiv alert alert-danger fade in alert-dismissable"
                    )
                }>
            <a className="close" onClick={() => this.oncloseErrPop()} data-dismiss="alert"
                aria-label="close" title="close" >×
            </a>
            <strong>Error!</strong> {this.props.activityErrMessage}
        </div>
          <Modal.Body>
            <div className={!this.state.isComment ? 'commentBox' : 'commentBox has-error'}>
              <div>
                <div className="txt-box-header txtCmtHeader">
                  Please enter comments (required):
                  {this.totalActivityHours() > 720 && (
                    <p className="text-danger">*Total hours exceeded 12 hours. please specify the reason</p>
                  )}
                  {
                    this.state.isComment ? <div className="reqFieldErr">Comments required</div> : ""
                  }
                </div>
              </div>
              <textarea ref="txtComments" className="form-control textarea-border"
                rows="20" cols="60" />
            </div>
          </Modal.Body>
          <Modal.Footer>
            {role === constants.roles.ADMIN_ROLE ? (
              this.renderAdminButton()
            ) : (
                this.renderEmployeeButton()
              )}
          </Modal.Footer>
        </Modal>
      );
    } else {
      <div />;
    }
  }
  render() {
    return this.renderCommentsModal();
  }
}

function mapStateToProps(state) {
  // coming from store
  return {
    showModal: state.modals.showModal,
    workday: state.workday.workday,
    defaultWorkday:state.workday.defaultWorkday,
    modalName: state.modals.modalName,
    role: state.role,
    action: state.modals.action,
    authDetails:state.authState,
    activityErrPopup: state.modals.activityErrPopup,
    activityErr: state.modals.activityErr,
    certifyError: state.modals.certifyError,
    activityErrMessage: state.modals.activityErrMessage
  };
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      onChangesInActivity: actions.changesInActivityAction,
      hideModal: actions.hideModalAction,
      onShowModal: actions.showModalAction,
      onCertify: actions.onCertifyAction,
      getWorkday: actions.getWorkdayAction,
      onRejectClaim: actions.onRejectClaimAction,
      onActErr: actions.actErrorAction,
      resetWorkday:actions.resetWorkdayAction,
      onCertifyHOSLog : actions.onCertifyHOSLogAction
    },
    dispatch
  );
}

CommentsModal.contextTypes = {
  location: PropTypes.object
}

export { CommentsModal };

export default connect(mapStateToProps, matchDispatchToProps)(CommentsModal);
